import { render, staticRenderFns } from "./HomeBlog.vue?vue&type=template&id=24e9cdaf&"
import script from "./HomeBlog.vue?vue&type=script&lang=js&"
export * from "./HomeBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e9cdaf')) {
      api.createRecord('24e9cdaf', component.options)
    } else {
      api.reload('24e9cdaf', component.options)
    }
    module.hot.accept("./HomeBlog.vue?vue&type=template&id=24e9cdaf&", function () {
      api.rerender('24e9cdaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/home/HomeBlog.vue"
export default component.exports